
(() => {
	if (document.querySelector('.part-cat-diagram')) {
		const pointItems = [].slice.call(document.querySelectorAll('[data-x]')),
			diagramContainer = document.querySelector('.part-cat-diagram'),
			diagramContainerWidth = diagramContainer.clientWidth,
			diagramContainerHeight = diagramContainer.clientHeight;

		pointItems.forEach(item => {
			const itemX = item.getAttribute('data-x'),
				itemY = item.getAttribute('data-y'),
				diagramItem = document.createElement('a'),
				hoverPoint = document.createElement('i'),
				infoContainer = document.createElement('div'),
				infoTitle = document.createElement('h3'),
				infoImg = document.createElement('img');

			diagramItem.className = 'part-cat-diagram__item';
			hoverPoint.className = 'part-cat-diagram__hover-point';
			infoTitle.className = 'part-cat-diagram__title';
			infoContainer.className = 'part-cat-diagram__container';

			diagramItem.style.left = itemX + '%';
			diagramItem.style.top = itemY + '%';
			diagramItem.setAttribute('href', item.querySelector('a').href);

			infoContainer.style[itemX > 50 ? 'right' : 'left'] = 0;

			infoImg.className = 'part-image'; // Adding class to infoImg
			infoImg.src = item.getAttribute('data-imageurl');
			infoImg.alt = item.getAttribute('data-alt')

			infoTitle.textContent = item.getAttribute('data-title');
			``
			infoContainer.appendChild(infoImg);
			infoContainer.appendChild(infoTitle);

			diagramItem.appendChild(infoContainer);
			diagramItem.appendChild(hoverPoint);
			diagramContainer.appendChild(diagramItem);
		});

		// Used to get coordinates for diagram points. Use shift + ctrl and click.
		diagramContainer.addEventListener('click', e => {
			if (e.shiftKey) {
				e.preventDefault();
				alert('Coordinates\n\nX Position: ' + (((e.offsetX / diagramContainerWidth) * 100) - 2).toFixed(2) + '\nY Position: ' + (((e.offsetY / diagramContainerHeight) * 100) - 4).toFixed(2));
			}
		});
	}
})();

let isScrolledToCategories = false;

function scrollToCategories() {
	const categoriesSection = document.querySelector('.diagrams-container');

	if (categoriesSection) {


		const scrollToPosition = categoriesSection.getBoundingClientRect().bottom + window.scrollY;

		if (window.scrollY < scrollToPosition) {
			window.scrollTo({
				top: scrollToPosition,
				behavior: "smooth"
			});
			isScrolledToCategories = true;
		}


	}
}

document.addEventListener('DOMContentLoaded', () => {
	const scollerButton = document.querySelector('.part-cat-scroller');
	if (scollerButton) {
		scollerButton.addEventListener('click', scrollToCategories);
	}
});